import { Box, Typography } from '@mui/material'

interface LayoverBlockProps {
    prefix: {
        layover: string
        in: string
    }
    layoverType: string
    layoverDuration: string
    layoverText: string
}

const LayoverBlock = ({ prefix, layoverType, layoverDuration, layoverText }: LayoverBlockProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: 'neutral.100',
                fontSize: '12px',
                px: 2,
                py: 1.5,
                my: 2,
                justifyContent: 'center'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography textAlign="center">
                    <Typography component="span" sx={{ fontWeight: 600, color: 'link.main', fontSize: 14 }}>
                        {prefix.layover}
                    </Typography>
                    <Typography component="span" sx={{ ml: 0.5, fontSize: 14, color: 'textColors.subtitle' }}>
                        {prefix.in}
                    </Typography>
                    <Typography component="span" sx={{ ml: 0.5, fontSize: 14, color: 'textColors.subtitle' }}>
                        {layoverText}
                    </Typography>
                    <Typography component="span" sx={{ ml: 0.5, fontSize: 14, color: 'error.main', fontWeight: 500 }}>
                        {layoverType}
                    </Typography>
                    <Typography component="span" sx={{ ml: 0.5, fontSize: 14, color: 'error.main', fontWeight: 500 }}>
                        {layoverDuration}
                    </Typography>
                </Typography>
            </Box>
        </Box>
    )
}

export default LayoverBlock
